import { connect } from "react-redux";
import React from "react";
import { Link } from "react-router-dom";

const HomePage = () => (
  <div className="jumbotron">
    <h1>Pixelinium website</h1>
    <Link to="starwards" className="btn btn-primary btn-lg">
      Learn more
    </Link>
  </div>
);

//HomePage.propTypes = {
//};

//function mapStateToProps(state) {
//    return {}
//}

//export default connect(mapStateToProps)(HomePage);
export default HomePage;
